/**
 * StatusPill — pill compacto com texto micro 11px e cor semântica.
 *
 * Props:
 *   children — conteúdo (string, normalmente)
 *   tone     — 'info' (default) | 'success' | 'warning' | 'danger' | 'neutral'
 */
const TONE_CLASSES = {
  info:    "bg-semantic-info/10 text-semantic-info border-semantic-info/20",
  success: "bg-semantic-success/10 text-semantic-success border-semantic-success/20",
  warning: "bg-semantic-warning/10 text-semantic-warning border-semantic-warning/20",
  danger:  "bg-semantic-danger/10 text-semantic-danger border-semantic-danger/20",
  neutral: "bg-white/5 text-slate-400 border-white/10",
};

export default function StatusPill({ children, tone = "info" }) {
  const cls = TONE_CLASSES[tone] || TONE_CLASSES.info;
  return (
    <span
      className={`inline-flex items-center text-[11px] leading-none px-2 py-0.5 rounded-full border ${cls}`}
      data-testid={`ds-status-pill-${tone}`}
    >
      {children}
    </span>
  );
}
